import type { RedistributionResult } from "../redistribution/models/RedistributionResult.ts";
import { useRedistributionQueueStore } from "../stores/redistributionQueueStore.ts";
import { useRedistributionStore } from "../stores/redistributionStore.ts";
import { resolveOriginalPurchaseOrders } from "../utils/originalPurchaseOrders.ts";
import { fetchTraceLog } from "./apiClient.ts";

/**
 * Loads a completed job into the results store, restoring the original POs so
 * Before & After can compare pre- and post-redistribution quantities.
 */
export function applyCompletedRedistributionResult(
  result: RedistributionResult,
  requestId: string
): void {
  const queueStore = useRedistributionQueueStore();
  const item = queueStore.items.find(
    (queued) => queued.requestId === requestId
  );

  const resultStore = useRedistributionStore();
  resultStore.setResult(
    result,
    resolveOriginalPurchaseOrders(
      result.updatedPurchaseOrderList,
      item?.originalPurchaseOrders
    ),
    requestId
  );
  resultStore.setBulkOrderDates(item?.bulkOrderDates);
  if (item?.requestBody) {
    resultStore.setLastCustomRequestBody(item.requestBody);
  }
}

export async function hydrateTraceLogFromResult(
  result: RedistributionResult
): Promise<void> {
  const store = useRedistributionStore();
  if (typeof result.traceLog === "string" && result.traceLog.length > 0) {
    store.setTraceLog(result.traceLog);
    return;
  }

  if (!result.traceLogBlobId) {
    store.setTraceLog(undefined);
    return;
  }

  try {
    store.setTraceLog(await fetchTraceLog(result.traceLogBlobId));
  } catch {
    store.setTraceLog(undefined);
  }
}
